import { UserTaxRegion } from '@freelancer/datastore/collections';
import { TaxTypeApi } from 'api-typings/common/common';

export const TAX_TYPE_MAPPING: Record<UserTaxRegion, readonly TaxTypeApi[]> = {
  [UserTaxRegion.EU]: [TaxTypeApi.VAT],
  [UserTaxRegion.IN]: [TaxTypeApi.TCS, TaxTypeApi.TDS],
  [UserTaxRegion.MX]: [TaxTypeApi.MXIT],
  [UserTaxRegion.US]: [TaxTypeApi.US1099K],
  [UserTaxRegion.PH]: [TaxTypeApi.VAT],
};

export enum TaxInformationToastItem {
  // Update tax information
  TAX_INFO_UPDATE_SUCCESS = 'tax-info-update-success',
  TAX_INFO_UPDATE_ERROR = 'tax-info-update-generic-error',
  TAX_NUMBER_INVALID = 'tax-number-invalid',
  TAX_NUMBER_DUPLICATE = 'tax-number-duplicate',
  // Deactivate tax information
  TAX_DEACTIVATE_SUCCESS = 'tax-deactivate-success',
  TAX_NUMBER_DOES_NOT_EXIST = 'tax-number-not-exist',
  TAX_DEACTIVATE_ERROR = 'tax-deactivate-generic-error',
  // Tax opt out
  TAX_OPT_OUT_SUCCESS = 'tax-opt-out-success',
  TAX_OPT_OUT_ERROR = 'tax-opt-out-generic-error',
  // Revert tax opt out
  REVERT_TAX_OPT_OUT_SUCCESS = 'revert-opt-out-success',
  TAX_OPT_OUT_NOT_FOUND = 'revert-opt-out-not-found',
  REVERT_TAX_OPT_OUT_ERROR = 'revert-opt-out-generic-error',
  // US TIN matching
  US_TAX_MATCH_REJECTED = 'us-tax-match-rejected',
  US_TAX_MATCH_COMMUNICATION_ERROR = 'us-tax-match-communication-error',
}
